import React from "react";
import { ProxyErrorConversion } from "../utils/Conversion";

export const ErrorText = ({ error }) => {

    if (!error)
        return <div />
    return <h3 style={{ color: "red", textAlign: "center", marginTop: 5 }}>{ProxyErrorConversion(error)}</h3>
}